import { snakeCase } from 'lodash';
import { ManufacturerNameArg, RobotManufacturer } from './robot.types';

const RobotManufacturerSet: Set<string> = new Set(
  Object.values(RobotManufacturer)
);

export const isRobotManufacturer = (
  value?: string | null
): value is RobotManufacturer => {
  if (!value) {
    return false;
  }
  return RobotManufacturerSet.has(value);
};

export const getManufacturerByName = (
  manufacturerName: ManufacturerNameArg
): RobotManufacturer | undefined => {
  const snakeCased = snakeCase(manufacturerName ?? '');

  if (isRobotManufacturer(snakeCased)) {
    return snakeCased;
  }
};
